<template>
  <div class="goodsInfoBox">
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>

      <el-breadcrumb-item v-if="beforePage.name && beforePage.name != 'Index'" :to="{ path: beforePage.fullPath }">{{ beforePage.name }}</el-breadcrumb-item>

      <el-breadcrumb-item>商品详情</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 商品信息box -->
    <div class="goodsInfo_head">
      <!-- 左侧商品图 -->
      <div class="goodsInfo_headL">
        <div class="goodsInfo_img">
          <img v-if="goodsData.pictures && picIndex != -1" :src="goodsData.pictures[picIndex]" alt="" style="width: 100%; height: 100%" />
          <video-player v-if="playerOptions.sources[0].src && picIndex == -1" class="video-player vjs-custom-skin" ref="videoPlayer" :playsline="false" :options="playerOptions"></video-player>
        </div>
        <div class="goodsInfo_imgList" v-if="goodsData.pictures" v-dragScroll>
          <div :class="['goodsInfo_imgBox', picIndex == -1 ? 'active' : '']" @click="picIndex = -1" v-if="goodsData.video">
            <img src="/static/image/videoPoster.png" alt="" style="width: 100%; height: 100%" />
            <!-- <video-player
              class="video-player vjs-custom-skin"
              ref="videoPlayer"
              :playsline="false"
              :options="playerOptions"
            ></video-player> -->
          </div>
          <div :class="['goodsInfo_imgBox', index == picIndex ? 'active' : '']" v-for="(item, index) in goodsData.pictures" :key="index" @click="picIndex = index">
            <img :src="item" alt="" style="width: 100%; height: 100%" />
          </div>
        </div>
      </div>
      <!-- 右侧商品信息 -->
      <div class="goodsInfo_headR">
        <div class="goodsInfo_headRBox">
          <span class="goodsInfo_headRText1">{{ goodsData.title }}</span>
          <span :class="[
              'goodsInfo_headCollection',
              isCollected ? 'collected' : ''
            ]" @click="addCollection"><i class="iconfont" :style="{
                'margin-right': 9 + 'px',
                'font-size': 20 + 'px',
                color: isCollected ? '#F89A00' : '#969696'
              }">{{ isCollected ? "&#xeb52;" : "&#xe7ed;" }}</i>收藏</span>
        </div>
        <span class="goodsInfo_headRText2">{{ goodsData.subtitle }}</span>
        <div class="tagBox" v-if="goodsData.tagInfoPcList && goodsData.tagInfoPcList.length > 0">
          <div class="tagList" v-for="(item, index) in goodsData.tagInfoPcList" :key="index">
            {{ item }}
          </div>
        </div>
        <div class="goodsInfo_headMain">
          <div class="goodsInfo_headMainList">
            <span class="goodsInfo_label">价格：</span>
            <span class="goodsInfo_headPrice" v-for="(item, index) in goodsData.intervalPriceList" :key="index" style="flex: 1">￥
              <span style="font-size: 21px" v-if="item.price">{{
                item.price.toFixed(2)
              }}</span>
              <!-- <span
                class="goodsInfo_headDisPrice"
                v-if="goodsData.pcProductPrice"
              >
                ￥{{ goodsData.pcProductPrice.toFixed(2) }}</span
              > -->
            </span>
          </div>
          <div class="goodsInfo_headMainList">
            <span class="goodsInfo_label" style="margin-right: 0">起批量：</span>
            <span class="goodsInfo_numRegion" v-for="(item, index) in goodsData.intervalPriceList" :key="index" style="flex: 1">
              <span v-if="index != goodsData.intervalPriceList.length - 1">{{ item.startNum }}-{{ item.endNum }}{{ goodsData.unit }}</span>
              <span v-else>≥{{ item.startNum }}{{ goodsData.unit }}</span>
            </span>
          </div>
          <!--  <div class="goodsInfo_headMainList" style="margin-left: 55px">
          <span class="goodsInfo_headTag">色泽金黄</span
            ><span class="goodsInfo_headTag">盐焗入味</span
            ><span class="goodsInfo_headTag">Q弹耐嚼</span>
          </div> -->
          <div class="goodsInfo_headMainList">
            <span class="goodsInfo_label">规格：</span>
            <div class="goodsInfo_headSpecs">{{ goodsData.spec }}</div>
          </div>
          <div class="goodsInfo_headMainList">
            <span class="goodsInfo_label">数量：</span>

            <div class="goodsInfo_headNum">
              <input type="text" class="goodsInfo_headNumIpt" oninput="value=value.replace(/[^\d]/g,'')" @change="changeNum()" v-model.number="goodsData.num" />
              <!-- <div class="goodsInfo_headNumIpt">{{ goodsData.num }}</div> -->
              <div class="goodsInfo_headNumBtn">
                <button class="goodsInfo_headNumAdd" style="transform: rotate(180deg)" @click="addNum()">
                  <i class="iconfont">&#xe624;</i>
                </button>
                <button class="goodsInfo_headNumAdd" @click="reduceNum()">
                  <i class="iconfont">&#xe624;</i>
                </button>
              </div>
              <span style="margin-right: 15px">{{ goodsData.unit }}</span>
              <!-- <span>库存867</span> -->
              <div class="minNumBox" v-if="goodsData.intervalPriceList">
                <!-- goodsData.pcMinBuyCount
                   ? goodsData.pcMinBuyCount
                   : goodsData.minBuyCount -->
                起订量：{{goodsData.intervalPriceList[0].startNum}}{{ goodsData.unit }}
              </div>
              <div class="totalPriceBox">
                小计：{{
                  (goodsData.num * goodsData.wholesalePrice).toFixed(2)
                }}
              </div>
            </div>
          </div>
          <div class="goodsInfo_headMainList" style="margin: 7px 0 0 55px">
            <el-button class="goodsInfo_headShopCarBtn" @click="addShopCar()">
              加入购物车</el-button>
            <el-button class="goodsInfo_headSubmitBtn" type="primary" @click="buyGoods()">
              立即购买</el-button>

            <span class="goodsInfo_headCollection contact" @click="visible = true"><img style="margin-right: 9px; width: 20px; height: 20px" src="../../../static/image/contact.png" />和我联系</span>
          </div>
          <span class="goodsInfo_tip" v-show="isZero">采购数量须大于最小起订量</span>
        </div>
      </div>
    </div>
    <!-- 底部推荐，商品详情 -->
    <div class="goodsInfo_main">
      <!-- 猜你喜欢 -->
      <!-- <div class="goodsInfo_mainL">
        <span class="goodsInfo_mainRecommend">——&nbsp;猜你喜欢&nbsp;——</span>
        <div class="goodsInfo_mainList">
          <img src="" alt="" />
          <span>￥ 33.80</span>
        </div>
      </div> -->
      <!-- 详情，评价 -->
      <div class="goodsInfo_mainR">
        <div class="goodsInfo_mainRNav">
          <div class="goodsInfo_mainTagBox">
            <div class="goodsInfo_mainTag goodsInfo_mainTagActive">
              商品详情
            </div>
            <!-- <div class="goodsInfo_mainTag">商品评价</div> -->
          </div>
          <!-- <div class="goodsInfo_mainRTopR">
            <span>手机购买</span>
            <i class="iconfont" style="font-size:20px;color:#707070"
              >&#xe63e;</i
            >
            <i class="iconfont" style="font-size:12px;color:#707070"
              >&#xe624;</i
            >
          </div> -->
        </div>
        <div v-html="goodsData.content" class="goodsInfo_mainContent"></div>

        <el-empty style="margin: 0 auto" description="暂无数据" v-if="!goodsData.content"></el-empty>
      </div>
    </div>
    <!-- 右侧nav -->
    <div class="right_nav">
      <div class="right_navList" @click="$router.push('/shopCar')">
        <i class="iconfont" style="font-size: 30px">&#xe690;</i><span>购</span><span>物</span><span>车</span>
        <span class="shopCarNum">{{ shopCarNum }}</span>
      </div>
      <div class="right_navList2">
        <div class="right_navList2_items">
          <i class="iconfont" style="font-size: 25px">&#xe6d1;</i>
        </div>
        <div class="right_navList2_items" style="border-top: 1px solid #fff" @click="visible = true">
          <i class="iconfont" style="font-size: 25px">&#xe613;</i>
        </div>
      </div>
      <div class="right_navList3" @click="gotoTop()">
        <i class="iconfont" style="font-size: 18px">&#xe666;</i>
        <span>返</span><span>回</span><span>顶</span><span>部</span>
      </div>
    </div>
    <Dialog :dialogVisible="visible" @closepop="visible = false"></Dialog>
  </div>
</template>

<script>
import { doGet } from "../common/HttpHelper.js";
import { httpConfig } from "../common/config.js";
import dialog from "../common/dialog.vue";
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";

export default {
  components: {
    Dialog: dialog,
    videoPlayer,
  },
  data() {
    return {
      visible: false,

      goodsData: "", //商品信息
      isCollected: false, //是否被收藏
      shopCarNum: 0, //选择商品数量
      picIndex: -1, //选中商品图的index
      shopCar: [], //购物车列表
      collectList: [], //收藏列表
      isZero: false,
      shopId: undefined, //判断购物车是否有此商品
      collectId: undefined, //判断收藏夹是否有此商品
      beforePage: {},

      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 静音播放
        loop: false, // 循环播放
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "285:299", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4", // 这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: "", // url地址
          },
        ],
        poster: "", // 你的封面地址
        width: document.documentElement.clientWidth, // 播放器宽度
        notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, // 全屏按钮
        },
      },
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // beforeRouteEnter不能通过this访问组件实例，但是可以通过 vm 访问组件实例
      vm.beforePage = { name: from.name, fullPath: from.fullPath }; //vm.demodata即this.demodata
    });
  },
  mounted() {
    if (this.beforePage && this.beforePage.name) {
      this.$store.commit("savePage", this.beforePage);
    } else {
      this.beforePage = this.$store.state.beforePage;
    }
    this.getShopCar(0); //获取购物车列表
    this.getShopCar(1); //获取收藏夹列表
    this.gotoTop();
    this.getList(this.$route.query.id); //获取商品详情
  },

  methods: {
    /**
     * 获取购物车和收藏夹
     */
    getShopCar(type) {
      var that = this;
      doGet(
        httpConfig.shopCar.getShopCarUrl,
        {  type },
        function (res) {
          if (res.flag) {
            if (type == 0) {
              that.shopCar = res.data;
              //计算购物车商品总数
              that.shopCarNum = 0;
              that.shopCar.forEach((item) => {
                item.info = JSON.parse(item.info);

                that.shopCarNum += item.info.num;
                if (item.info.id == that.$route.query.id) {
                  that.shopId = item.id;
                }
              });

              that.$store.commit("saveShopCarNum", that.shopCarNum);
            } else {
              that.collectList = res.data;
              //判断是否已被收藏
              that.isCollected = false;
              that.collectList.forEach((item) => {
                item.info = JSON.parse(item.info);
                if (item.info.id == that.$route.query.id) {
                  that.collectId = item.id;
                  that.isCollected = true;
                }
              });
              that.$store.commit("saveCollectNum", that.collectList.length);
            }
          }
        },
        function (res) {}
      );
    },
    /**
     * 增加数量
     */
    addNum() {
      var price = 0;
      if (this.goodsData.num == 0) {
        this.$set(
          this.goodsData,
          "num",
          // this.goodsData.pcMinBuyCount
          //   ? this.goodsData.pcMinBuyCount
          //   : this.goodsData.minBuyCount
          this.goodsData.intervalPriceList[0].startNum
        );
      } else {
        this.$set(this.goodsData, "num", this.goodsData.num + 1);
      }
      this.$forceUpdate();
      this.goodsData.intervalPriceList.forEach((item, index) => {
        if (
          index == this.goodsData.intervalPriceList.length - 1 &&
          this.goodsData.num >= item.startNum
        ) {
          price = item.price;
          return;
        } else if (
          index != this.goodsData.intervalPriceList.length - 1 &&
          this.goodsData.num >= item.startNum &&
          this.goodsData.num <= item.endNum
        ) {
          price = item.price;
          return;
        }
      });
      this.goodsData.wholesalePrice = price;
      if (
        this.goodsData.num >=
        // (this.goodsData.pcMinBuyCount
        //   ? this.goodsData.pcMinBuyCount
        //   : this.goodsData.minBuyCount)
        this.goodsData.intervalPriceList[0].startNum
      ) {
        this.isZero = false;
      }
    },
    /**
     * 减少数量
     */
    reduceNum() {
      if (
        this.goodsData.num >
        // (this.goodsData.pcMinBuyCount
        //   ? this.goodsData.pcMinBuyCount
        //   : this.goodsData.minBuyCount)
        this.goodsData.intervalPriceList[0].startNum
      ) {
        var price = 0;
        this.$set(this.goodsData, "num", this.goodsData.num - 1);
        this.$forceUpdate();
        this.goodsData.intervalPriceList.forEach((item, index) => {
          if (
            index == this.goodsData.intervalPriceList.length - 1 &&
            this.goodsData.num >= item.startNum
          ) {
            price = item.price;
            return;
          } else if (
            index != this.goodsData.intervalPriceList.length - 1 &&
            this.goodsData.num >= item.startNum &&
            this.goodsData.num <= item.endNum
          ) {
            price = item.price;
            return;
          }
        });
        this.goodsData.wholesalePrice = price;
      }
    },
    /**
     * 输入数量，检测阶梯价格
     */
    changeNum() {
      if (
        this.goodsData.num <
        // (this.goodsData.pcMinBuyCount
        //   ? this.goodsData.pcMinBuyCount
        //   : this.goodsData.minBuyCount)
        this.goodsData.intervalPriceList[0].startNum
      ) {
        this.goodsData.num =
          // this.goodsData.pcMinBuyCount
          // ? this.goodsData.pcMinBuyCount
          // : this.goodsData.minBuyCount;
          this.goodsData.intervalPriceList[0].startNum;
      }
      var price = 0;
      this.goodsData.intervalPriceList.forEach((item, index) => {
        if (
          index == this.goodsData.intervalPriceList.length - 1 &&
          this.goodsData.num >= item.startNum
        ) {
          price = item.price;
          return;
        } else if (
          index != this.goodsData.intervalPriceList.length - 1 &&
          this.goodsData.num >= item.startNum &&
          this.goodsData.num <= item.endNum
        ) {
          price = item.price;
          return;
        }
      });
      this.goodsData.wholesalePrice = price;
    },
    /**
     * 获取商品详情
     */
    getList(id) {
      var that = this;
      doGet(
        httpConfig.GoodsInfo.getDataUrl,
        { goodsId: id },
        function (res) {
          if (res.flag) {
            var price = 0;
            that.goodsData = JSON.parse(JSON.stringify(res.data));
            that.playerOptions.sources[0].src = that.goodsData.video;
            that.goodsData.video ? (that.picIndex = -1) : (that.picIndex = 0);
            that.goodsData["num"] =
              // that.goodsData.pcMinBuyCount
              // ? that.goodsData.pcMinBuyCount
              // : that.goodsData.minBuyCount;
              that.goodsData.intervalPriceList[0].startNum;
            that.goodsData.intervalPriceList.forEach((item, index) => {
              if (
                index == that.goodsData.intervalPriceList.length - 1 &&
                that.goodsData.num >= item.startNum
              ) {
                price = item.price;
                return;
              } else if (
                index != that.goodsData.intervalPriceList.length - 1 &&
                that.goodsData.num >= item.startNum &&
                that.goodsData.num <= item.endNum
              ) {
                price = item.price;
                return;
              }
            });
            that.goodsData.wholesalePrice = price;
          } else {
            that.$message({
              type: "error",
              message: res.message,
            });
          }
        },
        function (res) {}
      );
    },
    /**
     * 加入购物车
     */
    addShopCar() {
      if (this.goodsData.intervalPriceList.length == 0) {
        this.$message({
          type: "error",
          message: "商品价格异常",
        });
        return;
      }
      var that = this;
      if (this.$cookies.get("peopleId")) {
        if (
          this.goodsData.num <
          // (this.goodsData.pcMinBuyCount
          //   ? this.goodsData.pcMinBuyCount
          //   : this.goodsData.minBuyCount)
          this.goodsData.intervalPriceList[0].startNum
        ) {
          this.isZero = true;
        } else {
          this.isZero = false;
          var data = {
            num: this.goodsData.num,
            id: this.goodsData.id,
            isSelected: true,
          };
          doGet(
            httpConfig.shopCar.saveShopCarUrl,
            {
              id: that.shopId,
              info: JSON.stringify(data),
              type: 0,
            },
            function (res) {
              if (res.flag) {
                that.getShopCar(0);
                that.$message({
                  type: "success",
                  message: "加入购物车成功",
                });
              }
            },
            function (res) {}
          );
        }
      } else {
        this.$message.warning("请先登录");
        this.$router.push("/login");
      }
    },

    /**
     * 立即购买
     */
    buyGoods() {
      var that = this;
      if (this.goodsData.intervalPriceList.length == 0) {
        this.$message({
          type: "error",
          message: "商品价格异常",
        });
        return;
      }
      if (this.$cookies.get("peopleId")) {
        if (
          this.goodsData.num <
          // (this.goodsData.pcMinBuyCount
          //   ? this.goodsData.pcMinBuyCount
          //   : this.goodsData.minBuyCount)
          this.goodsData.intervalPriceList[0].startNum
        ) {
          this.isZero = true;
        } else {
          this.isZero = false;
          var data = {
            num: this.goodsData.num,
            id: this.goodsData.id,
          };
          this.$store.commit("saveBuyList", [data]);
          this.$router.push({ path: "/orderPay", query: { type: 1 } });
        }
      } else {
        this.$message.warning("请先登录");
        this.$router.push("/login");
      }
    },
    /**
     * 加入收藏
     */
    addCollection() {
      var that = this;
      if (this.goodsData.intervalPriceList.length == 0) {
        this.$message({
          type: "error",
          message: "商品价格异常",
        });
        return;
      }
      if (this.$cookies.get("peopleId")) {
        var data = {
          id: this.goodsData.id,
          isSelected: false,
        };
        if (that.isCollected) {
          doGet(
            httpConfig.shopCar.deleteShopCarUrl,
            {
              id: that.collectId,
              type: 1,
            },
            function (res) {
              if (res.flag) {
                that.isCollected = false;

                that.$store.commit(
                  "saveCollectNum",
                  that.$store.state.collectNum - 1
                );
                that.collectId = undefined;
                that.$message({
                  type: "success",
                  message: "取消收藏成功!",
                });
              }
            },
            function (res) {}
          );
        } else {
          doGet(
            httpConfig.shopCar.saveShopCarUrl,
            {
              info: JSON.stringify(data),
              type: 1,
            },
            function (res) {
              if (res.flag) {
                that.collectId = res.data;
                that.isCollected = true;
                that.$store.commit(
                  "saveCollectNum",
                  that.$store.state.collectNum + 1
                );
                that.$message({
                  type: "success",
                  message: "收藏成功",
                });
              }
            },
            function (res) {}
          );
        }
      } else {
        this.$message.warning("请先登录");
        this.$router.push("/login");
      }
    },
    /**
     * 返回顶部
     */
    gotoTop() {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop =
          document.documentElement.scrollTop =
          top -=
            50;
        if (top <= 0) {
          clearInterval(timeTop);
        }
      }, 10);
    },
  },
};
</script>

<style scoped>
@import "../../assets/css/goodsInfo";
</style>



// WEBPACK FOOTER //
// src/components/page/goodsInfo.vue